<script>
	import Footer from '$lib/components/footer.svelte';
import Header from '$lib/components/header.svelte';
import { initHomeSwiper, initVenueSwiper } from '$lib/js/swiper.js';
	import { onMount } from 'svelte';


    export let data;
    let info = data?.info;
    let detail = data?.venueDetail;
    let venue = data?.venue;
    // console.log('Detail Venue Data', detail);

    onMount(() => {
        initVenueSwiper();
        initHomeSwiper();
    });

</script>

<svelte:head>
  <title>{detail?.name} - Jimbaran Convention Center</title>
</svelte:head>

<Header info={info} />

<section>
    <div class="swiper mySwiperHero">
        <div class="swiper-wrapper">
            <div class="swiper-slide !h-[50vh] sm:!h-[calc(100vh-8vh-70px)] relative">
                <div class="h-full w-full overflow-hidden">
                    <img src="{detail.featured_images[0].path}" class="w-full h-full object-cover object-center" alt="">
                </div>
                <!-- <div class="absolute top-0 h-full w-full bg-[#252525]/50 flex justify-center items-end">
                    <p class="uppercase font-secondary text-center pb-[8rem] text-white leading-[120%] text-[2rem] sm:text-[3rem]">{detail.name}</p>
                </div> -->
            </div>
        </div>
        <!-- <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div> -->
    </div>
</section>

<section class="py-[5rem] relative">
    <img src="/images/bg-primary.webp" class="w-full h-[70%] absolute top-0 z-[1] object-bottom object-cover" alt="">

    <div class="container flex flex-col sm:flex-row justify-between relative z-[2] mb-10">
        <div class="w-full sm:w-[40%]">
            <p class="uppercase text-primary font-secondary text-[2rem] leading-[120%] mb-[20px] sm:mb-[50px]">{detail.name}</p>
            <div class="mb-[20px]">
                <ul class="ont-primary flex flex-wrap gap-5">
                    {#if detail?.type}
                        <li class="flex items-center text-[1rem] px-[10px] py-[5px] text-primary gap-1  bg-[#e8e8e8] rounded-[5px] shadow-[0_4px_30px_rgba(0,0,0,0.1)]">
                            <svg xmlns="http://www.w3.org/2000/svg" class="fill-primary" width="20" height="20" viewBox="0 0 256 256"><path d="M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z"></path></svg>
                            <p class="italic">{detail.type}</p>
                        </li>
                    {/if}
                    {#if detail.feature?.size}
                        <li class="flex items-center text-[1rem] px-[10px] py-[5px] text-primary gap-1  bg-[#e8e8e8] rounded-[5px] shadow-[0_4px_30px_rgba(0,0,0,0.1)]">
                            <svg xmlns="http://www.w3.org/2000/svg" class="fill-primary" width="20" height="20" viewBox="0 0 256 256"><path d="M216,48V96a8,8,0,0,1-16,0V67.31l-50.34,50.35a8,8,0,0,1-11.32-11.32L188.69,56H160a8,8,0,0,1,0-16h48A8,8,0,0,1,216,48ZM106.34,138.34,56,188.69V160a8,8,0,0,0-16,0v48a8,8,0,0,0,8,8H96a8,8,0,0,0,0-16H67.31l50.35-50.34a8,8,0,0,0-11.32-11.32Z"></path></svg>
                            <p class="italic">{detail.feature.size}</p>
                        </li>
                    {/if}
                    {#if detail.feature?.capacity}
                        <li class="flex items-center text-[1rem] px-[10px] py-[5px] text-primary gap-1  bg-[#e8e8e8] rounded-[5px] shadow-[0_4px_30px_rgba(0,0,0,0.1)]">
                            <svg xmlns="http://www.w3.org/2000/svg" class="fill-primary" width="20" height="20" viewBox="0 0 256 256"><path d="M244.8,150.4a8,8,0,0,1-11.2-1.6A51.6,51.6,0,0,0,192,128a8,8,0,0,1-7.37-4.89,8,8,0,0,1,0-6.22A8,8,0,0,1,192,112a24,24,0,1,0-23.24-30,8,8,0,1,1-15.5-4A40,40,0,1,1,219,117.51a67.94,67.94,0,0,1,27.43,21.68A8,8,0,0,1,244.8,150.4ZM190.92,212a8,8,0,1,1-13.84,8,57,57,0,0,0-98.16,0,8,8,0,1,1-13.84-8,72.06,72.06,0,0,1,33.74-29.92,48,48,0,1,1,58.36,0A72.06,72.06,0,0,1,190.92,212ZM128,176a32,32,0,1,0-32-32A32,32,0,0,0,128,176ZM72,120a8,8,0,0,0-8-8A24,24,0,1,1,87.24,82a8,8,0,1,0,15.5-4A40,40,0,1,0,37,117.51,67.94,67.94,0,0,0,9.6,139.19a8,8,0,1,0,12.8,9.61A51.6,51.6,0,0,1,64,128,8,8,0,0,0,72,120Z"></path></svg>
                            <p class="italic">Max Capacity: {detail.feature.capacity}</p>
                        </li>
                    {/if}
                    {#if detail.feature?.location}
                        <li class="flex items-center text-[1rem] px-[10px] py-[5px] text-primary gap-1  bg-[#e8e8e8] rounded-[5px] shadow-[0_4px_30px_rgba(0,0,0,0.1)]">
                            <svg xmlns="http://www.w3.org/2000/svg"class="fill-primary" width="20" height="20" viewBox="0 0 256 256"><path d="M120,103.2V176a8,8,0,0,0,16,0V103.2a40,40,0,1,0-16,0ZM128,40a24,24,0,1,1-24,24A24,24,0,0,1,128,40ZM240,176c0,31.18-57.71,48-112,48S16,207.18,16,176c0-7.74,3.81-19.13,22-29.41,12.26-6.94,29.12-12.27,48.77-15.42A8,8,0,1,1,89.27,147c-17.54,2.82-33,7.63-43.42,13.55C37.05,165.5,32,171.14,32,176c0,13.36,36.52,32,96,32s96-18.64,96-32c0-4.86-5.05-10.5-13.85-15.49-10.46-5.92-25.88-10.73-43.42-13.55a8,8,0,1,1,2.54-15.79c19.65,3.15,36.51,8.48,48.77,15.42C236.19,156.87,240,168.26,240,176Z"></path></svg>
                            <p class="italic">{detail.feature.location}</p>
                        </li>
                    {/if}
                </ul>
            </div>
        </div>
        <div class="w-full sm:w-[40%]">
            <div class="text-primary font-primary mb-5">
                {@html detail.description}
            </div>
            <div>
                {#if detail?.virtual_view}
                    <a href="{detail.virtual_view}" target="_blank" class="uppercase font-primary text-primary border border-primary py-[10px] px-[20px] inline-block transition-all duration-300 hover:bg-primary hover:text-white mr-2">360 View</a>
                {/if}
				<a href="mailto:apdpshamice@ihg.com?subject=Booking%20Venue" class="uppercase font-primary bg-primary text-white border border-primary py-[10px] px-[20px] inline-block transition-all duration-300 hover:bg-[#252525] hover:text-white hover:border-secondary">Book Venue</a>
			</div>
        </div>
    </div>
    <!-- <div class="container mt-[20px] sm:mt-[5rem] px-[20px] sm:pb-[4rem] relative z-[2] py-[3rem]">
		<div class="flex items-center gap-5">
			<span class="w-full h-[1px] bg-secondary block"></span>
			<p class="font-secondary text-primary text-[1.5rem] sm:text-[2rem] leading-[120%] uppercase whitespace-nowrap">Venue Images</p>
			<span class="w-full h-[1px] bg-secondary block"></span>
		</div>
	</div> -->

    <div class="container block sm:hidden ">
        <div class="swiper mySwiperVenueImage !rounded-xl">
            <div class="swiper-wrapper">
                {#each detail.featured_images as img}
                    <div class="swiper-slide">
                        <img src="{img.path}" class="aspect-square w-full object-cover" alt="" loading="lazy">
                    </div>
                {/each}
            </div>
            <div class="swiper-button-next swiper-button-next-imgvenue rounded-full after:!content-[unset] !w-[40px] !h-[40px] fill-white bg-primary/30 backdrop-blur-[10px] border border-white transition-all duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"></path></svg>
            </div>
            <div class="swiper-button-prev swiper-button-prev-imgvenue rounded-full after:!content-[unset] !w-[40px] !h-[40px] fill-white bg-primary/30 backdrop-blur-[10px] border border-white transition-all duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path></svg>
            </div>
            <div class="swiper-pagination swiper-pagination-imgvenue !text-white"></div>
        </div>
    </div>

    <div class="container relative z-[2] hidden sm:block">
        <div class="swiper mySwiperVenueImage">
            <div class="swiper-wrapper">
                {#each detail.featured_images as img}
                    <div class="swiper-slide">
                        <img src="{img.path}" class="aspect-[16/9] w-full object-cover" alt="">
                    </div>
                {/each}
            </div>
            <div class="flex items-end absolute bottom-[30px] right-[30px] gap-5">
                <div class="swiper-pagination swiper-pagination-imgvenue !text-white !inline-block !static !w-[unset] !text-[1.8rem] !font-secondary"></div>
                <div class="swiper-button-prev swiper-button-prev-imgvenue !static after:!content-[unset] !w-[70px] !h-[70px] fill-white bg-primary/30 backdrop-blur-[10px] border border-white transition-all duration-300">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path></svg>
                </div>
                <div class="swiper-button-next swiper-button-next-imgvenue !static after:!content-[unset] !w-[70px] !h-[70px] fill-white bg-primary/30 backdrop-blur-[10px] border border-white transition-all duration-300">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"></path></svg>
                </div>
            </div>
        </div>
    </div>

</section>


<!-- Other Venue  -->
<section class="pb-[4rem]">
    <div class="container relative pb-[3rem]">
		<div class="sm:px-[10vw]">
			<div class="flex items-center gap-5">
				<p class="font-secondary text-primary text-[1.5rem] sm:text-[2rem] leading-[120%] uppercase whitespace-nowrap">Other Venue</p>
				<span class="w-full h-[1px] bg-secondary block"></span>
			</div>
		</div>
	</div>
	<div class="container mb-[3rem]">
		<div class="swiper mySwiperHomeVenue">
			<div class="swiper-wrapper">

                {#each venue as item}
                <div class="swiper-slide">
                    <a data-sveltekit-reload href="/venues/{item.slug}" class="w-full aspect-[.7] overflow-hidden block relative group">
                        <img src="{item.featured_images[0].path}" class="w-full h-full object-cover transition-all duration-300 group-hover:scale-125" alt="">
                        <div class="absolute top-0 w-full h-full flex flex-col justify-end bg-gradient-to-b from-transparent to-black">
                            <div class="w-full px-[20px] pb-[30px]">
                                <p class="text-white text-center uppercase font-secondary text-[1.5rem] mb-[10px]">{item.name}</p>
                                <ul class="font-primary flex justify-center gap-3 py-[20px]">
                                    <li class="flex items-center text-[.8rem] px-[8px] py-[5px] text-white gap-1  bg-white/30 rounded-[15px] shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[1px] border border-white/30">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="fill-white" width="15" height="15" viewBox="0 0 256 256"><path d="M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z"></path></svg>
                                        <p class="italic">{item.type}</p>
                                    </li>
                                    {#if item.feature.capacity}
                                    <li class="flex items-center text-[.8rem] px-[8px] py-[5px] text-white gap-1  bg-white/30 rounded-[15px] shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[1px] border border-white/30">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="fill-white" width="15" height="15" viewBox="0 0 256 256"><path d="M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z"></path></svg>
                                        <p class="italic">Max Capacity: {item.feature.capacity}</p>
                                    </li>
                                    {/if}
                                </ul>
                                <p class="font-primary text-center text-white">{item.excerpt}</p>
                            </div>
                        </div>
                    </a>
                </div> 
                {/each}
	
			</div>
			<div class="swiper-button-next after:!content-[unset] fill-white !h-[40px] !w-[40px]  bg-primary/30  shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[1px] border border-white transition-all duration-300 hover:bg-primary">
				<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"></path></svg>
			</div>
			<div class="swiper-button-prev after:!content-[unset] fill-white !h-[40px] !w-[40px]  bg-primary/30  shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[1px] border border-white transition-all duration-300 hover:bg-primary">
				<svg xmlns="http://www.w3.org/2000/svg" width="25" height="35" viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path></svg>
			</div>
		</div>
	</div>
</section>

<Footer info={info} />